(function () {
  'use strict';

  function mount(scope) {
    const host = scope.matches && scope.matches('[data-cc-builder]')
      ? scope
      : scope.querySelector('[data-cc-builder]');

    if (!host || host.dataset.initialized) return;

    const node = host.querySelector('[data-mix-config]');
    if (!node || !window.CandyMix) return;

    let config;

    try {
      config = JSON.parse(node.textContent);
    } catch (error) {
      console.error('Candy Corner: invalid builder configuration.', error);
      return;
    }

    host.dataset.initialized = 'true';

    const {
      sizes,
      mainLimit,
      validate,
      swedishCount,
      findPricedVariant,
      buildCartItem
    } = window.CandyMix;

    const $ = selector => host.querySelector(selector);

    const flavours = config.flavours.filter(
      f => typeof f.name === 'string' && f.name.trim()
    );

    const key = 'cc-shopify-mix-' + config.sectionId;

    let draft = {
      size: '',
      main: [],
      backups: []
    };

    let busy = false;

    const esc = value => String(value).replace(
      /[&<>"']/g,
      c => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[c])
    );

    const available = id => flavours.some(
      f => f.id === id && f.available !== false
    );

    function money(cents) {
      try {
        return new Intl.NumberFormat(
          document.documentElement.lang || 'en-CA',
          {
            style: 'currency',
            currency: config.currency || 'CAD'
          }
        ).format(cents / 100);
      } catch (error) {
        return (cents / 100).toFixed(2) +
          ' ' + (config.currency || 'CAD');
      }
    }

    function baseVariant(id) {
      return config.sizes.find(s => s.id === id);
    }

    function selectedVariant() {
      if (!draft.size) return null;
      return findPricedVariant(draft, config);
    }

    function hasAvailableVariants(sizeId) {
      return (config.pricedVariants || []).some(
        v => v.size === sizeId && v.variantId && v.available
      );
    }

    function sizeUsable(sizeId) {
      const base = baseVariant(sizeId);

      return !!(
        config.hasProduct &&
        base &&
        base.variantId &&
        base.available
      );
    }

    function variantUsable() {
      const selected = selectedVariant();

      return !!(
        config.hasProduct &&
        selected &&
        selected.variantId &&
        selected.available
      );
    }

    try {
      const saved = JSON.parse(
        localStorage.getItem(key) || 'null'
      );

      if (saved) {
        draft.size = sizes.some(
          s => s.id === saved.size
        ) ? saved.size : '';

        draft.main = Array.isArray(saved.main)
          ? [...new Set(saved.main.filter(available))]
              .slice(0, mainLimit(draft.size))
          : [];

        draft.backups = Array.isArray(saved.backups)
          ? [...new Set(saved.backups.filter(
              id => available(id) && !draft.main.includes(id)
            ))].slice(0, 3)
          : [];

        if (!draft.size) {
          draft = {
            size: '',
            main: [],
            backups: []
          };
        }
      }
    } catch (error) {
      // Start with an empty bag if saved selections are invalid.
    }

    // CANDY CORNER PACKAGING PREFERENCE
    // Available for exactly two identical 1 kg mixes.

    const quantityInput = $('#mix-quantity');

    const packagingBox = document.createElement('div');

    packagingBox.id = 'cc-packaging-choice';
    packagingBox.hidden = true;

    packagingBox.style.cssText =
      'margin:18px 0;' +
      'padding:18px;' +
      'border:1px solid #ead6e5;' +
      'border-radius:14px;' +
      'background:#fff7fc;';

    packagingBox.innerHTML = `
      <p style="margin:0 0 14px;font-weight:700;">
        how would you like your candy packed? 🍬
      </p>

      <label style="display:flex;align-items:center;gap:10px;margin-bottom:14px;cursor:pointer;">
        <input
          type="radio"
          name="cc-packaging"
          value="separate"
          checked
        >
        <span>2 separate 1 kg bags</span>
      </label>

      <label style="display:flex;align-items:center;gap:10px;cursor:pointer;">
        <input
          type="radio"
          name="cc-packaging"
          value="combined"
        >
        <span>1 large 2 kg bag (combined)</span>
      </label>

      <small style="display:block;margin-top:14px;line-height:1.5;">
        no extra charge! both options contain the same
        amount of candy.
      </small>
    `;

    quantityInput.insertAdjacentElement(
      'afterend',
      packagingBox
    );

    // Identify the 1 kg size without assuming a specific ID.
    function isOneKilo() {
      const size = sizes.find(s => s.id === draft.size);

      if (!size) return false;

      const label = [
        size.id,
        size.name,
        size.label
      ].join(' ').toLowerCase();

      return /(^|[^a-z0-9])1\s*kg([^a-z0-9]|$)/i.test(label) ||
        /(^|[^a-z0-9])1000\s*g([^a-z0-9]|$)/i.test(label) ||
        /(^|[^a-z0-9])kilo([^a-z0-9]|$)/i.test(label);
    }

    function packagingEligible() {
      return isOneKilo() &&
        Number(quantityInput.value) === 2;
    }

    function updatePackagingChoice() {
      const eligible = packagingEligible();

      packagingBox.hidden = !eligible;

      if (!eligible) {
        const separate = packagingBox.querySelector(
          'input[value="separate"]'
        );

        separate.checked = true;
      }
    }

    function selectedPackaging() {
      if (!packagingEligible()) return null;

      const selected = packagingBox.querySelector(
        'input[name="cc-packaging"]:checked'
      );

      return selected && selected.value === 'combined'
        ? '1 large 2 kg bag (combined)'
        : '2 separate 1 kg bags';
    }

    function renderSizes() {
      $('#sizes').innerHTML = sizes.map(s => {
        const v = baseVariant(s.id);
        const usable = sizeUsable(s.id);
        const selected = draft.size === s.id;

        const priceLabel = usable
          ? esc(money(v.price))
          : config.hasProduct
            ? 'unavailable'
            : 'coming soon';

        return `
          <label class="size-option ${selected ? 'is-selected' : ''} ${usable ? '' : 'cc-size-unavailable'}">
            <input
              type="radio"
              name="bag-size"
              value="${esc(s.id)}"
              ${selected ? 'checked' : ''}
              ${usable ? '' : 'disabled'}
            >
            <span>
              <strong>${esc(s.name)}</strong>
              <small>${esc(s.label)}</small>
              <small>${priceLabel}</small>
            </span>
          </label>
        `;
      }).join('');
    }

    function renderChoices(type) {
      const main = type === 'main';
      const chosen = main ? draft.main : draft.backups;
      const other = main ? draft.backups : draft.main;
      const max = main ? mainLimit(draft.size) : 3;

      const search = $(
        main ? '#main-search' : '#backup-search'
      ).value.toLowerCase().trim();

      const category = $('#main-filter').value;

      const list = flavours.filter(f =>
        f.name.toLowerCase().includes(search) &&
        (
          !main ||
          category === 'all' ||
          (
            category === 'Sour'
              ? f.name.toLowerCase().includes('sour')
              : f.category === category
          )
        )
      );

      const target = $(
        main ? '#main-choices' : '#backup-choices'
      );

      target.innerHTML = list.length
        ? list.map(f => {
            const checked = chosen.includes(f.id);
            const inOther = other.includes(f.id);
            const outOfStock = f.available === false;
            const atLimit = chosen.length >= max && !checked;

            const categoryText =
              f.category === 'Swedish'
                ? 'swedish candy · +$1.99'
                : f.category === 'Sour'
                  ? 'sour favourite'
                  : 'gummy classic';

            const description = outOfStock
              ? 'currently unavailable'
              : inOther
                ? (
                    main
                      ? 'already a backup'
                      : 'already in your main mix'
                  )
                : main
                  ? categoryText
                  : f.category === 'Swedish'
                    ? 'swedish backup · no upfront charge'
                    : f.category === 'Sour'
                      ? 'sour favourite'
                      : 'gummy classic';

            return `
              <label class="gummy-option ${checked ? 'is-selected' : ''} ${inOther || atLimit || outOfStock ? 'is-unavailable' : ''}">
                <input
                  type="checkbox"
                  data-choice="${type}"
                  value="${esc(f.id)}"
                  ${checked ? 'checked' : ''}
                  ${inOther || atLimit || outOfStock ? 'disabled' : ''}
                >
                ${f.image ? `<img src="${esc(f.image)}" alt="${esc(f.name)}" class="gummy-image" loading="lazy">` : ''}
                <span>
                  <strong>${esc(f.name)}</strong>
                  <small>${esc(description)}</small>
                </span>
                <span class="choice-mark" aria-hidden="true">
                  ${checked ? '✓' : '+'}
                </span>
              </label>
            `;
          }).join('')
        : '<p class="no-gummies">no matching gummies. try another search.</p>';
    }

    function renderList(selector, ids, fallback) {
      $(selector).innerHTML = ids.length
        ? ids.map(id => {
            const f = flavours.find(f => f.id === id);
            if (!f) return '';

            const extra =
              selector === '#summary-main' &&
              f.category === 'Swedish'
                ? ' (+$1.99)'
                : '';

            return `<li>${esc(f.name + extra)}</li>`;
          }).join('')
        : `<li class="summary-empty">${esc(fallback)}</li>`;
    }

    function render() {
      renderSizes();

      // Update the packaging selector whenever
      // bag size or quantity changes.
      updatePackagingChoice();

      const limit = mainLimit(draft.size);

      $('#main-step').disabled = !draft.size;

      $('#backup-step').disabled =
        !draft.size || !draft.main.length;

      $('#main-count').textContent =
        draft.main.length + ' / ' + limit;

      $('#backup-count').textContent =
        draft.backups.length + ' / 3';

      $('#summary-main-count').textContent =
        draft.main.length + ' / ' + limit;

      $('#summary-backup-count').textContent =
        draft.backups.length + ' / 3';

      const size = sizes.find(s => s.id === draft.size);

      $('#summary-size').textContent = size
        ? size.name + ' · ' + size.label
        : 'choose a size';

      $('#main-help').textContent = !draft.size
        ? 'choose your size first, then pick your gummy varieties.'
        : draft.main.length === limit
          ? 'all ' + limit +
            ' spots are filled. uncheck one to swap a gummy.'
          : 'choose 1–' + limit +
            ' gummy varieties. swedish gummies are +$1.99 each.';

      renderChoices('main');
      renderChoices('backup');

      renderList(
        '#summary-main',
        draft.main,
        'your favourites will appear here.'
      );

      renderList(
        '#summary-backups',
        draft.backups,
        'pick 2–3 extras, just in case.'
      );

      const result = validate(draft, flavours);

      const base = baseVariant(draft.size);
      const selected = selectedVariant();

      const stock = !!(
        config.hasProduct &&
        base &&
        base.variantId &&
        base.available
      );

      const selectedStock = variantUsable();

      const qty = Number($('#mix-quantity').value);

      const quantityValid =
        Number.isInteger(qty) &&
        qty >= 1 &&
        qty <= 20;

      const count = swedishCount(draft, flavours);

      $('#save-bag').disabled =
        busy ||
        !result.valid ||
        !stock ||
        !selectedStock ||
        !quantityValid;

      $('#save-bag').innerHTML = busy
        ? 'adding your mix…'
        : 'add to cart <span>↗</span>';

      let status;

      if (!config.hasProduct) {
        status =
          'this mix is being prepared. please check back soon.';
      } else if (
        !config.sizes.some(v => v.variantId && v.available)
      ) {
        status = 'this mix is currently unavailable.';
      } else if (!draft.size) {
        status = 'choose your bag size to get started.';
      } else if (!stock) {
        status =
          'this size is unavailable. please choose another.';
      } else if (!draft.main.length) {
        status =
          'choose at least 1 gummy for your main mix.';
      } else if (!selectedStock) {
        status =
          'this combination of bag size and swedish gummies is unavailable. please adjust your choices.';
      } else if (draft.backups.length < 2) {
        const remaining = 2 - draft.backups.length;

        status = 'choose ' + remaining +
          ' more backup ' +
          (remaining === 1 ? 'variety.' : 'varieties.');
      } else if (!result.valid) {
        status = result.errors.join(' ');
      } else if (!quantityValid) {
        status = 'choose between 1 and 20 bags.';
      } else {
        status = 'your mix is ready.';
      }

      $('#builder-status').textContent = busy
        ? 'adding your mix to the cart…'
        : status;

      $('#builder-status').classList.toggle(
        'is-ready',
        result.valid &&
        stock &&
        selectedStock &&
        quantityValid &&
        !busy
      );

      if (stock) {
        const basePrice = Number(base.price) || 0;

        if (selected && selected.variantId) {
          const finalPrice = Number(selected.price) || 0;
          const total = finalPrice * (quantityValid ? qty : 1);

          const upgradeAmount = finalPrice - basePrice;

          const upgradeLabel = count
            ? ' · swedish upgrades: ' +
              money(upgradeAmount) + ' per bag'
            : '';

          $('#mix-price').textContent =
            'bag price: ' + money(basePrice) +
            upgradeLabel +
            ' · total: ' + money(total);
        } else {
          $('#mix-price').textContent =
            'this swedish gummy combination is unavailable.';
        }
      } else {
        $('#mix-price').textContent =
          'choose an available size to see the price.';
      }

      try {
        localStorage.setItem(key, JSON.stringify(draft));
      } catch (error) {
        // The builder can still work without local storage.
      }
    }

    $('#builder-form').addEventListener('change', e => {
      const target = e.target;

      $('#cart-success').hidden = true;

      if (target.name === 'bag-size') {
        draft.size = target.value;

        draft.main = draft.main.slice(
          0,
          mainLimit(draft.size)
        );

        render();
        return;
      }

      if (target.dataset.choice) {
        const type = target.dataset.choice;

        const arr = type === 'main'
          ? draft.main
          : draft.backups;

        const other = type === 'main'
          ? draft.backups
          : draft.main;

        const max = type === 'main'
          ? mainLimit(draft.size)
          : 3;

        if (target.checked) {
          if (
            arr.length >= max ||
            other.includes(target.value) ||
            !available(target.value)
          ) {
            target.checked = false;
            return;
          }

          arr.push(target.value);
        } else {
          const index = arr.indexOf(target.value);

          if (index >= 0) {
            arr.splice(index, 1);
          }
        }

        const selectedId = target.value;

        render();

        for (const choice of host.querySelectorAll('[data-choice]')) {
          if (
            choice.dataset.choice === type &&
            choice.value === selectedId &&
            !choice.disabled
          ) {
            choice.focus({ preventScroll: true });
            break;
          }
        }
      }
    });

    $('#main-search').addEventListener(
      'input',
      () => renderChoices('main')
    );

    $('#backup-search').addEventListener(
      'input',
      () => renderChoices('backup')
    );

    $('#main-filter').addEventListener(
      'change',
      () => renderChoices('main')
    );

    $('#mix-quantity').addEventListener('input', render);

    $('#builder-form').addEventListener(
      'submit',
      async e => {
        e.preventDefault();

        if (busy) return;

        const qty = Number($('#mix-quantity').value);

        let item;

        try {
          item = buildCartItem(draft, config, qty);

          // Save the customer's packaging preference
          // as a Shopify line item property.
          const packaging = selectedPackaging();

          if (packaging) {
            item.properties = {
              ...(item.properties || {}),
              'Packaging preference': packaging
            };
          }

        } catch (error) {
          $('#builder-status').textContent = error.message;
          return;
        }

        busy = true;
        render();

        try {
          const response = await fetch(
            config.root + 'cart/add.js',
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({
                items: [item]
              })
            }
          );

          const result = await response.json();

          if (!response.ok) {
            throw new Error(
              typeof result.description === 'string'
                ? result.description
                : 'we couldn’t add your mix. please try again.'
            );
          }

          $('#cart-success').hidden = false;

          $('#builder-status').textContent =
            'your mix is in the cart.';

          try {
            localStorage.removeItem(key);
          } catch (error) {
            // No action needed.
          }

          window.location.assign(config.cartUrl);

        } catch (error) {
          busy = false;
          render();

          $('#builder-status').textContent =
            error.message ||
            'connection problem. your choices are safe—please try again.';
        }
      }
    );

    render();
  }

  function boot() {
    for (const host of document.querySelectorAll('[data-cc-builder]')) {
      mount(host);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener(
    'shopify:section:load',
    e => mount(e.target)
  );

})();